import React from 'react';
import { getPasswordStrength } from '../utils/passwordValidation';
import { Shield, AlertCircle, CheckCircle } from 'lucide-react';

const PasswordStrengthIndicator = ({ password, requirements }) => {
  const { strength, label, color } = getPasswordStrength(password);
  
  const getColorClasses = () => {
    switch (color) {
      case 'red':
        return 'bg-red-500 text-red-700 border-red-200';
      case 'orange':
        return 'bg-blue-500 text-blue-700 border-blue-200';
      case 'green':
        return 'bg-green-500 text-green-700 border-green-200';
      case 'blue':
        return 'bg-blue-500 text-blue-700 border-blue-200';
      default:
        return 'bg-gray-300 text-gray-700 border-gray-200';
    }
  };
  
  const getTextColorClass = () => {
    switch (color) {
      case 'red':
        return 'text-red-700';
      case 'orange':
        return 'text-blue-700';
      case 'green':
        return 'text-green-700';
      case 'blue':
        return 'text-blue-700';
      default:
        return 'text-gray-700';
    }
  };

  if (!password) return null;

  return (
    <div className="space-y-3 mt-2">
      {/* Strength Bar */}
      <div className="space-y-1">
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-600">Password Strength:</span>
          <span className={`text-xs font-semibold ${getTextColorClass()}`}>
            {label}
          </span>
        </div>
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-full transition-all duration-300 ${getColorClasses().split(' ')[0]}`}
            style={{ width: `${(strength / 9) * 100}%` }}
          />
        </div>
      </div>

      {/* Requirements Checklist */}
      {requirements && (
        <div className="bg-gray-50 border rounded p-3 space-y-2">
          <p className="text-xs font-semibold text-gray-700 mb-2">Password must contain:</p>
          {requirements.errors && requirements.errors.length > 0 ? (
            requirements.errors.map((error, idx) => (
              <div key={idx} className="flex items-center gap-2 text-xs text-gray-600">
                <AlertCircle className="w-3 h-3 text-blue-500 flex-shrink-0" />
                <span>{error}</span>
              </div>
            ))
          ) : (
            <div className="flex items-center gap-2 text-xs text-green-600">
              <CheckCircle className="w-3 h-3 flex-shrink-0" />
              <span>All requirements met</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PasswordStrengthIndicator;
